module.exports = require("tailwindcss/resolveConfig");